<div class="modal fade" bsModal #staticModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
  aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-sm" style="width: 400px;">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-events-name" class="modal-title pull-left">Account Logo</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="closeLogoUpload()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <input id="fileuploader" name="files[0]" accept="image/*" style="margin:15px;" type="file"
          (change)="onFileChanged($event)" value="Choose Image" />
        <div *ngIf="accountLogo!=null" class="text-center">
          <img id="uploadPreview" alt="selected account logo" style="max-height: 100px;max-width: 300px;" />
          <button class="btn btn-block btn-info btn-sm" style="margin-top: 10px;" (click)="uploadFile()">
            <i class="fa fa-cloud-upload" style="margin-right:5px;"></i>Upload</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div bsModal #customizationPopup="bs-modal" class="modal fade" [config]="{backdrop: 'static'}" tabindex="-1"
  role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-events-name" class="modal-title pull-left">Add custom fields</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="closeCustomFieldPopUp()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="text-center">Do you want to customize the fields for this account ?.</div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-sm btn-success" [routerLink]="['/field-customization/',createdAccountId]"
          (click)="closeCustomFieldPopUp()">
          <i class="fa fa-check" style="margin-right:5px;"></i>Yes</button>
        <button class="btn btn-sm btn-danger" (click)="closeCustomFieldPopUp()">
          <i class="fa fa-close" style="margin-right:5px;"></i>No</button>
      </div>
    </div>
  </div>
</div>

<div class="card-header">
  <span [ngSwitch]="listing">
    <span *ngSwitchCase="false">Add/Update Account</span>
    <span *ngSwitchCase="true">Existing Accounts</span>
  </span>
  <button class="btn btn-sm btn-warning float-right" (click)="toggleView()"
    style="font-size: 14px;margin-top: -4px;background-color:  rgb(87,200,231);color: #ffffff;height:38px;">
    <span *ngIf="listing" tooltip="Click here to add a new account">
      <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> New Account</span>
    <span *ngIf="!listing">
      <i class="fa fa-arrow-left" style="margin-top:6px;color:#fff;"></i> Back</span>
  </button>
</div>
<div class="content-body padding-top-20 padding-bottom-20">
  <div class="row">
    <div *ngIf="listing; then tableTemplate; else wizardTemplate;">
    </div>
    <ng-template #tableTemplate>
     

    <p-table 
    [value]="accounts"
    [lazy]="true"
    (onLazyLoad)="onPageChange($event)"
    [paginator]="accounts != null && accounts.length > 0"
    [rows]="rows"
    [first]="paging.currentPage"
    [totalRecords]="totalRecords"
    class="table table-striped"

    #dt
      >
        <ng-template pTemplate="header">
          <tr style="height: 65px;">
            <th class="col-lg-6" style="width:100px;text-align: center;">#
            </th>
            <th>Account - Code
            </th>
            <th>Contact Information
            </th>
            <th>Address
            </th>
            <th>Logo
            </th>
            <th>
              Language
            </th>
          </tr>
          <tr  style="font-family:Arial, FontAwesome;text-align: center;">
            <td class="primeng-table-search">
              <!-- <input class="primeng-table-search-field" disabled pInputText type="search"
                (input)="dt.filter($event.target.value, 'address', 'contains')"> -->
            </td>
            <td class="primeng-table-search">
              <input class="primeng-table-search-field  search-bar-true" placeholder="&#xf002;  Account name or code"
                pInputText type="text" (input)="onSearch($event.target.value,'nameorcode')">
            </td>
            <td class="primeng-table-search">
              <input class="primeng-table-search-field  search-bar-true" placeholder="&#xf002;  E-mail" pInputText
                type="text" (input)="onSearch($event.target.value,'email')">
            </td>
            <td class="primeng-table-search">
              <!-- <input class="primeng-table-search-field" disabled pInputText type="search"
                (input)="dt.filter($event.target.value, 'address', 'contains')"> -->
            </td>
            <td class="primeng-table-search">
              <!-- <input class="primeng-table-search-field" disabled pInputText type="search"
                (input)="dt.filter($event.target.value, 'name', 'contains')"> -->
            </td>
            <td class="primeng-table-search">
              <input class="primeng-table-search-field  search-bar-true" placeholder="&#xf002;  Language" pInputText
                type="text" (input)="onSearch($event.target.value,'language')">
            </td>
          </tr>
          <tr *ngIf="accounts==null || accounts.length==0"
            style="border-left: 1px solid #f4f4f4;border-right: 1px solid #f4f4f4;border-bottom: 1px solid #f4f4f4;">
            <td colspan="6">
              <div style="padding: 5px;text-align: center;">
                No record found
              </div>
            </td>
          </tr>
          
        </ng-template>
        <ng-template pTemplate="body" let-account let-i="rowIndex">
          <tr class="table-striped" style="cursor: pointer;">
            <td style="text-align: center;" (click)="editAccountInfo(account)">
              {{i+1}}
            </td>
            <td (click)="editAccountInfo(account)">{{account.name}}
              <span *ngIf="account.accountCode!=null"> - {{account.accountCode}}</span>
            </td>
            <td (click)="editAccountInfo(account)">{{account.email}}
              <br> {{account.mobile}}
            </td>
            <td (click)="editAccountInfo(account)">{{getAddressString(account.address)}}</td>
            <td>
              <!-- <img (click)="updateAccountLogo(account)" src="{{account.logo}}" style="max-height: 100px;"
                class="img-responsive" onerror="this.src='assets/images/no-logo.png'" /> --> 
       
              <img
                (click)="updateAccountLogo(account)"
                [src]="account.logo? account.logo : defaultLogo"
                (error)="setDefaultLogo($event)"
                class="img-responsive"
                style="max-height: 100px;"
              /> 
            </td>
            <td>{{account.language}}</td>
          </tr>
        </ng-template>
      </p-table>
    </ng-template>
    <ng-template #wizardTemplate>
      <aw-wizard #wizard [defaultStepIndex]="0" navBarLayout="large-filled-symbols">
        <aw-wizard-step awSelectedStep [stepId]="1" [stepTitle]="'Account Info'" [navigationSymbol]="{ symbol: '1'}">
          <form #accountinfoForm="ngForm" class="mTop30">
            <div class="row margin-top30">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div class=" form-group">
                  <label class="form-label">Account Name
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="desc">Account/Organisation Name</span>
                  <div class="controls">
                    <input type="text" (keyup)="validateAccountInfo('name')" class="form-control" id="accountName" 
                    pattern="^[a-zA-Z0-9&,-. ]*" name="accountName" placeholder="Enter account name here..." #accountName="ngModel"   
                      [(ngModel)]="accountInfo.name" required />
                    <!-- <div [hidden]="accountName.valid || accountName.pristine" class="danger-text">
                      Account Name is required
                    </div> -->
                     
                    <div *ngIf="accountName.errors && accountName.dirty" class="danger-text">
                      <div *ngIf="accountName.errors.required">
                        Account Name is required
                      </div>
                      <div *ngIf="accountName.errors.pattern"> 
                        Incorrect input, allowed alphanumerics and special chars (& , . -)
                      </div>
                      <div *ngIf="nameExists" class="danger-text">
                        Account Name already exists
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div class=" form-group">
                  <label class="form-label">Account Code
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="desc">Account code/Short name of your Account/Organisation</span>
                  <div class="controls">
                    <span *ngIf="accountInfo.id!=null">{{accountInfo.accountCode}}</span>
                    <div *ngIf="accountInfo.id==null">
                      <input type="text" minlength="3" (keyup)="validateAccountInfo('code')" required  
                        pattern="^[a-zA-Z0-9]*" maxlength="5" [(ngModel)]="accountInfo.accountCode"
                        #accountCode="ngModel" name="accountCode" id="accountCode" class="form-control"
                        placeholder="Enter account code here..." />
                      <div [hidden]="accountCode.valid || accountCode.pristine" class="danger-text">
                        Valid Account code(3-5 alphanumeric character) is required
                      </div>
                      <div *ngIf="accountCodeExists" class="danger-text">
                        Account code already exits
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
                <div class=" form-group">
                  <label class="form-label">Is Trial Account?
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="desc"></span>
                  <div class="controls">
                    <div class="chiller_cb">
                      <div class="chiller_cb">
                        <input id="isTrial" [(ngModel)]="accountInfo.isTrial" name="isTrial" type="checkbox" />
                        <label style="font-weight: normal;" for="isTrial">Select if trial account</label>
                        <span></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" *ngIf="accountInfo.isTrial">
                <div class=" form-group">
                  <label class="form-label">Trial Duration
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="desc">Duration in days</span>
                  <div class="controls">
                    <input type="number" min="1" max="99" pattern="^[1-9][0-9]?$|^50$" class="form-control"
                      id="trialDuration" name="trialDuration" placeholder="Enter trial duration here..."
                      #trialDuration="ngModel" [(ngModel)]="accountInfo.trialDays" required />
                    <!-- <div *ngIf="trialDuration.errors && trialDuration.dirty" class="danger-text"> -->
                    <div [hidden]="trialDuration.valid || trialDuration.pristine || trialDuration.errors.pattern"
                      class="danger-text">
                      Trial Duration is required
                    </div>
                    <div *ngIf="trialDuration.errors!=null && trialDuration.errors.pattern" class="danger-text">
                      Trial Duration range should be 1 day to 99 days
                    </div>
                    <!-- </div> -->
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" [ngClass]="{'clear-both':accountInfo.isTrial}">
                <div class=" form-group">
                  <label class="form-label">Contact Email
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="desc">Email for communication with account/organisation</span>
                  <div class="controls">
                    <input type="email" (keyup)="validateAccountInfo('email')" name="email" id="email"
                      pattern="[a-zA-Z0-9_.+\-]{1,}@[a-zA-Z.-]{2,}\.[a-zA-Z]{2,}" #email="ngModel"
                      [(ngModel)]="accountInfo.email" class="form-control" placeholder="Enter email address here..."
                      required />
                    <div *ngIf="email.errors && email.dirty" class="danger-text">
                      <div *ngIf="email.errors.required">
                        Email is required
                      </div>
                      <div *ngIf="email.errors.pattern">
                          Invalid input, please check and enter correct details.
                      </div>
                    </div>
                    <div *ngIf="emailExists" class="danger-text">
                      Account Email already exits
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" [ngClass]="{'clear-both':!accountInfo.isTrial}">
                <div class=" form-group">
                  <label class="form-label">Contact Mobile
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="desc">Mobile for communication with account/organisation</span>
                  <div class="controls">
                    <input type="text" (keyup)="validateAccountInfo('mobile')" (keypress)="_keyPress($event)"
                      [(ngModel)]="accountInfo.mobile" ng-pattern="/^[0-9]*$/" #mobile="ngModel" name="mobile"
                      id="mobile" class="form-control" placeholder="Enter mobile number here..." required />
                    <div [hidden]="mobile.valid || mobile.pristine" class="danger-text">
                      Mobile number is required
                    </div>
                    <div *ngIf="mobileExists" class="danger-text">
                      Account mobile number already exits
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" [ngClass]="{'clear-both':accountInfo.isTrial}">
                <div class=" form-group">
                  <label class="form-label">Address Line 1
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="desc">Flat/Door/Block No</span>
                  <div class="controls">
                    <input type="text" [(ngModel)]="accountInfo.address.addressLine1" #addressLine1="ngModel"  
                    pattern=".*[a-zA-Z0-9].*" name="addressLine1" id="addressLine1" class="form-control"
                      placeholder="Enter address line1 here..." required />
                    <!-- <div [hidden]="addressLine1.valid || addressLine1.pristine" class="danger-text">
                      Address Line1 is required
                    </div> -->
                   
                    <div *ngIf="addressLine1.errors && addressLine1.dirty" class="danger-text">
                      <div *ngIf="addressLine1.errors.required">
                        Address Line1 is required
                      </div>
                      <div *ngIf="addressLine1.errors.pattern">
                        Invalid input, please check and enter correct details.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" [ngClass]="{'clear-both':!accountInfo.isTrial}">
                <div class=" form-group">
                  <label class="form-label">AddressLine 2
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="desc">Area/Locality</span>
                  <div class="controls">
                    <input type="text" [(ngModel)]="accountInfo.address.addressLine2" #addressLine2="ngModel"   
                    pattern=".*[a-zA-Z0-9].*" name="addressLine2" id="addressLine2" class="form-control"
                      placeholder="Enter address line2 here..." required />
                    <!-- <div [hidden]="addressLine2.valid || addressLine2.pristine" class="danger-text">
                      Address Line2 is required
                    </div> -->
                    <div *ngIf="addressLine2.errors && addressLine2.dirty" class="danger-text">
                      <div *ngIf="addressLine2.errors.required">
                        Address Line2 is required
                      </div>
                      <div *ngIf="addressLine2.errors.pattern">
                        Invalid input, please check and enter correct details.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" [ngClass]="{'clear-both':accountInfo.isTrial}">
                <div class=" form-group">
                  <label class="form-label">District
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="desc">District/City/Town</span>
                  <div class="controls">
                    <input type="text" [(ngModel)]="accountInfo.address.district" #district="ngModel" name="district"  
                    pattern=".*[a-zA-Z].*"  id="district" class="form-control" placeholder="Enter district here..." required />
                    <!-- <div [hidden]="district.valid || district.pristine" class="danger-text">
                      District is required
                    </div> -->
                    <div *ngIf="district.errors && district.dirty" class="danger-text">
                      <div *ngIf="district.errors.required">
                        District is required
                      </div>
                      <div *ngIf="district.errors.pattern">
                        Invalid input, please check and enter correct details.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" [ngClass]="{'clear-both':!accountInfo.isTrial}">
                <div class=" form-group">
                  <label class="form-label">State
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="desc">State</span>
                  <div class="controls">
                    <input type="text" [(ngModel)]="accountInfo.address.state" #state="ngModel" name="state" id="state"  
                    pattern="^[a-zA-Z ]*"  class="form-control" placeholder="Enter state here..." required />
                    <!-- <div [hidden]="state.valid || state.pristine" class="danger-text">
                      State is required
                    </div> -->
                    <div *ngIf="state.errors && state.dirty" class="danger-text">
                      <div *ngIf="state.errors.required">
                        State is required
                      </div>
                      <div *ngIf="state.errors.pattern">
                        Invalid input, please check and enter correct details.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" [ngClass]="{'clear-both':accountInfo.isTrial}">
                <div class=" form-group">
                  <label class="form-label">Pincode
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="desc">Pincode</span>
                  <div class="controls">
                    <input type="text" [(ngModel)]="accountInfo.address.zipcode" #pincode="ngModel" name="pincode"  
                    pattern="^[0-9 ]*" id="pincode" class="form-control" placeholder="Enter pincode here..." required />
                    <!-- <div [hidden]="pincode.valid || pincode.pristine" class="danger-text">
                      Pincode is required
                    </div> -->
                    <div *ngIf="pincode.errors && pincode.dirty" class="danger-text">
                      <div *ngIf="pincode.errors.required">
                        Pincode is required
                      </div>
                      <div *ngIf="pincode.errors.pattern">
                        Invalid input, please check and enter correct details.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" [ngClass]="{'clear-both':!accountInfo.isTrial}">
                <div class=" form-group">
                  <label class="form-label">Country
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="desc">Country</span>
                  <div class="controls">
                    <input type="text" [(ngModel)]="accountInfo.address.country" #country="ngModel" name="country"  
                    pattern="^[a-zA-Z ]*" id="country" class="form-control" placeholder="Enter country here..." required />
                    <!-- <div [hidden]="country.valid || country.pristine" class="danger-text">
                      Country name is required
                    </div> -->
                    <div *ngIf="country.errors && country.dirty" class="danger-text">
                      <div *ngIf="country.errors.required">
                        Country is required 
                      </div>
                      <div *ngIf="country.errors.pattern">
                        Invalid input, please check and enter correct details.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" [ngClass]="{'clear-both':accountInfo.isTrial}">
                <div class=" form-group">
                  <label class="form-label">Language
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="desc">Official/Communication language</span>
                  <div class="controls">
                    <select [(ngModel)]="accountInfo.language" required class="form-select form-select-sm" #language="ngModel"
                      id="language" name="language">
                      <option *ngFor="let language of languageList" [ngValue]="language.alpha2">{{language.English}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>-->
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div class=" form-group">
                  <label class="form-label">Languages
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="desc">List of languages available for the users</span>
                  <div class="controls">
                    <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="masterLanguageList"
                      (onSelect)="languageModified($event,'ADD')" (onDeSelect)="languageModified($event,'REMOVE')"
                      (onSelectAll)="languageModified($event,'ADD_ALL')"
                      (onDeSelectAll)="languageModified($event,'REMOVE_ALL')" name="masterLanguageList"
                      [(ngModel)]="selectedMasterLanguageList">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"
                *ngIf="selectedMasterLanguageList!=null && selectedMasterLanguageList.length>0">
                <div class=" form-group">
                  <label class="form-label">Default Language
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="desc">Default language for account</span>
                  <div class="controls">
                    <select [(ngModel)]="defaultLanguage" required class="form-select form-select-sm" #language="ngModel"
                      id="language" name="language">
                      <option [ngValue]="null">Select Default Language</option>
                      <option *ngFor="let language of defaultLanguageList" [ngValue]="language.id">{{language.itemName}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" [ngClass]="{'clear-both':!accountInfo.isTrial}">
                <div class=" form-group">
                  <label class="form-label">Timezone
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="desc"></span>
                  <div class="controls">
                    <select [(ngModel)]="accountInfo.timeZone" required class="form-select form-select-sm" #timezone="ngModel"
                      id="timezone" name="timezone">
                      <option *ngFor="let timezone of timeZoneList" [ngValue]="timezone.offset">{{timezone.text}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div class=" form-group">
                  <label class="form-label">Date Format
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="desc"></span>
                  <div class="controls">
                    <select [(ngModel)]="accountInfo.dateFormat" required class="form-select form-select-sm" #timezone="ngModel"
                      id="dateformat" name="dateformat">
                      <option *ngFor="let format of dateFormatList" [ngValue]="format">{{format}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" [ngClass]="{'clear-both':accountInfo.isTrial}">
                <div class=" form-group">
                  <label class="form-label">AI Feature</label>
                  <span class="desc"></span>
                  <div class="controls">
                    <div class="chiller_cb">
                      <input id="myCheckbox" [(ngModel)]="accountInfo.isAIEnabled" name="isAIEnabled" type="checkbox" />
                      <label style="font-weight: normal;" for="myCheckbox">AI Assistance to review</label>
                      <span></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" *ngIf="accountInfo.isAIEnabled"
                [ngClass]="{'clear-both':!accountInfo.isTrial}">
                <div class="form-group">
                  <label class="form-label" for="ai-provider">AI Providers</label>
                  <span class="desc"></span>
                  <div class="controls">
                    <!--<angular2-multiselect class="form-control" [data]="aiProviders" name="availableAIProviders"
                      #availableAIProviders="ngModel" [(ngModel)]="accountInfo.aiProviders"
                      [settings]="{ enableSearchFilter: true}">
                    </angular2-multiselect>-->
                    <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="aiProviders"
                      name="availableAIProviders" #availableAIProviders="ngModel" [(ngModel)]="accountInfo.aiProviders">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
              </div>
              <br>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div class=" form-group">
                  <label class="form-label" for="reading-center">Reading Center</label>
                  <span class="desc"></span>
                  <div class="controls">
                    <!--<angular2-multiselect class="form-control" [settings]="{ enableSearchFilter: true,maxHeight:200}"
                      [data]="readingCenters" name="availableReadingCenters" #availableReadingCenters="ngModel"
                      [(ngModel)]="accountInfo.readingCenters">
                    </angular2-multiselect>-->
                    <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="readingCenters"
                      name="availableReadingCenters" #availableReadingCenters="ngModel"
                      [(ngModel)]="accountInfo.readingCenters">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div class=" form-group">
                  <label class="form-label" for="spectacle-vendor">Spectacle Vendor</label>
                  <span class="desc"></span>
                  <div class="controls">
                    <!--<angular2-multiselect class="form-control" [settings]="{ enableSearchFilter: true}"
                      [data]="spectacleVendors" name="availableSpectacleVendors" #availableSpectacleVendors="ngModel"
                      [(ngModel)]="accountInfo.spectacleVendors">
                    </angular2-multiselect>-->
                    <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="spectacleVendors"
                      name="availableSpectacleVendors" #availableSpectacleVendors="ngModel"
                      [(ngModel)]="accountInfo.spectacleVendors">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div class=" form-group">
                  <label class="form-label" for="spectacle-vendor">Roles can manage payment</label>
                  <span class="desc">Only selected roles can buy the packages</span>
                  <div class="controls">
                    <!--<angular2-multiselect class="form-control" [settings]="{ enableSearchFilter: true}"
                      (ngModelChange)="paymentRolesUpdate($event)" [data]="allRoles" name="allRoles"
                      [(ngModel)]="assignedRoles">
                    </angular2-multiselect>-->
                    <ng-multiselect-dropdown [settings]="paymentRoledropdownSettings"
                      (ngModelChange)="paymentRolesUpdate($event)" [data]="allRoles" name="allRoles"
                      [(ngModel)]="assignedRoles">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
              </div>
              <!--<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        <div class=" form-group">
                          <label class="form-label">Subscription Type</label>
                          <span class="desc">Prepaid/Postpaid</span>
                          <div class="controls">{{subscriptionType}}
                            <input type="radio"  style="margin-right: 5px;width: 1.5em;vertical-align: middle;margin-top: 0px;;" name="subscriptionType" value="PREPAID" [(ngModel)]="accountInfo.subscriptionType"><label style="font-weight: normal;color:black;vertical-align: middle;">Pre-Paid</label>
                            <input type="radio"  style="margin-left:10px;margin-right: 5px;width: 1.5em;vertical-align: middle;margin-top: 0px;" name="subscriptionType" value="POSTPAID" [(ngModel)]="accountInfo.subscriptionType"><label style="font-weight: normal;color:black;vertical-align: middle;">Post-Paid</label>
                          </div>
                        </div>
                      </div>-->
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div class=" form-group">
                  <label class="form-label">Subscription Type</label>
                  <span class="desc">Prepaid/Postpaid</span>
                  <div class="controls" style="padding-top:5px">
                    <label class="switch padding-top-20">
                      <input type="checkbox" [(ngModel)]="subscriptionType" name="subscriptionType">
                      <div class="slider">
                        <!--ADDED HTML -->
                        <span class="off" style="color:white">Prepaid</span>
                        <span class="on" style="color:white;" ngInit>Postpaid</span>
                        <!--END-->
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" *ngIf="subscriptionType">
                <div class=" form-group">
                  <label class="form-label">Acount valid upto
                    <span
                      *ngIf="accountInfo.accountValidityDate==null || accountInfo.accountValidityDate.length==0">(Lifetime
                      valid if no date selected)</span>
                  </label>
                  <span class="desc">Account will be valid till the selected date</span>
                  <div class="controls" style="padding-top:5px">
                    <input type="date" [(ngModel)]="accountInfo.accountValidityDate" name="accountValidityDate"
                      id="accountValidityDate" class="form-control" style="width:80%" min="{{today}}"
                      onkeydown="return false">
                    <button class="btn btn-sm btn-warning" style="width:20%" (click)="clearAccountValidityDate()">Clear
                      Date</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" style="padding-left: 0;">
              <div class=" form-group">
                <label class="form-label">Acount keyword</label>
                <span class="desc"></span>
                <div class="controls" style="padding-top:5px">
                  <select [(ngModel)]="accountInfo.accountKeyword" name="accountKeyword" id="accountKeyword"
                    class="form-select form-select-sm">
                    <option value="null">Select Keyword</option>
                    <!-- <option value="AIIMS">AIIMS</option> -->
                    <option value="ESSILOR">Essilor</option>
                    <option value="HCL">HCL</option>
                    <option value="LOFTY">Lofty</option>
                    <option value="SADGURU">Sadguru</option>
                    <option value="SIGHT_SAVERS">Sight Savers</option>
                    <!-- <option value="THAILAND">Thailand</option> -->
                  </select>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 " style="padding-left: 0;">
              <div class=" form-group">
                <label class="form-label">Manual MRN</label>
                <span class="desc"></span>
                <div class="controls">
                  <div class="chiller_cb">
                    <input id="manualMRN" [(ngModel)]="accountInfo.isManualMRN" name="manualMRN" type="checkbox" />
                    <label style="font-weight: normal;" for="manualMRN">Manual MRN Entry</label>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both" style="padding-left: 0;">
              <div class=" form-group">
                <label class="form-label">Can Operator Email Reports?</label>
                <span class="desc"></span>
                <div class="controls" style="padding-top:5px">
                  <div class="chiller_cb">
                    <input id="enableEmailReport" [(ngModel)]="accountInfo.isEmailReportEnabled"
                      name="enableEmailReport" type="checkbox" />
                    <label style="font-weight: normal;" for="enableEmailReport">Yes</label>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>

            <!--<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">-->
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 " style="padding-left: 0;">
              <div class=" form-group">
                <label class="form-label">Enable Password-Protected Emails</label>
                <span class="desc"></span>
                <div class="controls">
                  <div class="chiller_cb">
                    <input id="enableEmailReportEncryption" [(ngModel)]="accountInfo.enableEmailReportEncryption" name="enableEmailReportEncryption" type="checkbox" />
                    <label style="font-weight: normal;" for="enableEmailReportEncryption">Yes</label>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both" style="padding-left: 0;">
              <div class=" form-group">
                <label class="form-label">Need Patient Profile Picture On Registration?</label>
                <span class="desc"></span>
                <div class="controls">
                  <div class="chiller_cb">
                    <input id="patientProfilePic" [(ngModel)]="accountInfo.patientPicNeed" name="patientProfilePic"
                      type="checkbox" />
                    <label style="font-weight: normal;" for="patientProfilePic">Capture Patient Profile
                      Picture</label>
                    <span></span>
                  </div>
                </div>
              </div>
              <div>
                <div class=" form-group">
                  <label class="form-label">Account has operators who is individual Owner?</label>
                  <span class="desc"></span>
                  <div class="controls">
                    <div class="chiller_cb">
                      <input id="hasIndividualOwner" [(ngModel)]="accountInfo.hasIndividualOwner"
                        name="hasIndividualOwner" type="checkbox" />
                      <label style="font-weight: normal;" for="hasIndividualOwner">Has individual owner?</label>
                      <span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" style="padding-left: 0;">
              <div class=" form-group">
                <label class="form-label">Enable 2-Step Authentication</label>
                <span class="desc"></span>
                <div class="controls">
                  <div class="chiller_cb">
                    <input id="isLoginOTPRequired" [(ngModel)]="accountInfo.isLoginOTPRequired"
                      name="isLoginOTPRequired" type="checkbox" />
                    <label style="font-weight: normal;" for="isLoginOTPRequired">OTP Based Authentication</label>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" style="padding-left: 0;" hidden>
              <div class=" form-group">
                <label class="form-label">Enable automatic emailing of the patient reports?</label>
                <span class="desc"></span>
                <div class="controls">
                  <div class="chiller_cb">
                    <input id="autoEmailPatientReport" [(ngModel)]="accountInfo.autoEmailPatientReport"
                      name="autoEmailPatientReport " type="checkbox" />
                    <label style="font-weight: normal;" for="autoEmailPatientReport">Auto email patient report</label>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Start here -->
            <!-- Appointment Booking section Start -->
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" style="padding-left: 0;">
              <div class=" form-group">
                <label class="form-label">Enable Screening Events?</label>
                <span class="desc"></span>
                <div class="controls">
                  <div class="chiller_cb">
                    <input id="enableScreeningEvents" [(ngModel)]="accountInfo.enableScreeningEvents"
                      name="enableScreeningEvents " type="checkbox" />
                    <label style="font-weight: normal;" for="enableScreeningEvents">Yes</label>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Appointment Booking  section END -->
            <!-- Slot Duration section Start -->
            <div *ngIf="accountInfo.enableScreeningEvents">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" style="padding-left: 0;">
                <div class=" form-group">
                  <label class="form-label">Select Slot Duration(In Minutes) </label>
                  <span class="desc"></span>
                  <div class="controls">
                    <ng-select [items]="slotDurations" [(ngModel)]="accountInfo.slotDuration" name="slotsDuration"
                      bindLabel="name" [clearable]="true" [searchable]="true" bindValue="id"
                      placeholder="Select Slot Duration">
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>
            <!-- Slot Duration section END -->
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" style="padding-left: 0;" hidden>
              <div class=" form-group">
                <label class="form-label">Enable automatic email and SMS notifications for newly registered
                  patients?</label>
                <span class="desc"></span>
                <div class="controls">
                  <div class="chiller_cb">
                    <input id="smsSentToRegisteredPatient"
                      [(ngModel)]="accountInfo.enableSMSNotificationOnPatientRegistration"
                      name="smsSentToRegisteredPatient " type="checkbox" />
                    <label style="font-weight: normal;" for="smsSentToRegisteredPatient">SMS</label>
                    <span></span>
                  </div>
                  <div class="chiller_cb">
                    <input id="emailSentToRegisteredPatient"
                      [(ngModel)]="accountInfo.enableEmailNotificationOnPatientRegistration"
                      name="emailSentToRegisteredPatient " type="checkbox" />
                    <label style="font-weight: normal;" for="emailSentToRegisteredPatient">Email</label>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
            <!-- End Heree -->
            <div class="form-group text-center col-xs-12" style="padding-left: 0;">
              <button type="button" style="margin:20px;margin-left: 10px;margin-right:10px;" uiSref="work"
                class="btn btn-info btn-raised" [awGoToStep]="{stepIndex: 1}" (click)="validateNotificationConfig()"
                [disabled]="!accountinfoForm.form.valid || nameExists || emailExists || mobileExists || accountCodeExists || !defaultLanguage || !selectedMasterLanguageList || selectedMasterLanguageList.length==0">
                Next
                <span style="margin-left:10px;">
                  <i class="feather ft-chevron-right"></i>
                </span>
              </button>
            </div>


          </form>
        </aw-wizard-step>
        <aw-wizard-step awOptionalStep [stepId]="2" *ngIf="accountInfo.id==null" [stepTitle]="'Account Admin Info'"
          [navigationSymbol]="{ symbol: '2'}">
          <form #admininfoForm="ngForm" class="mTop30">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label">Title
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Salutation</span>
                <div class="controls">
                  <select [(ngModel)]="userInfo.title" class="form-select form-select-sm" #userTitle="ngModel" id="userTitle"
                    name="userTitle">
                    <option value="Dr.">Dr.</option>
                    <option value="Mr.">Mr.</option>
                    <option value="Mrs.">Mrs.</option>
                    <option value="Miss.">Miss.</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label">Gender
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Sex/Gender</span>
                <div class="controls">
                  <select [(ngModel)]="userInfo.gender" class="form-select form-select-sm" #userGender="ngModel" id="userGender"
                    name="userGender">
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label">First Name
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">First Name</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="userInfo.firstName" #firstName="ngModel" name="firstName"  
                  pattern="^[a-zA-Z ]*" id="firstName" class="form-control" placeholder="Enter first name here..." required />
                  <!-- <div [hidden]="firstName.valid || firstName.pristine" class="danger-text">
                    First name is required
                  </div> -->
                  <div *ngIf="firstName.errors && firstName.dirty" class="danger-text">
                    <div *ngIf="firstName.errors.required">
                      First Name is required 
                    </div>
                    <div *ngIf="firstName.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label">Last Name</label>
                <span class="desc">Last Name/Surname</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="userInfo.lastName" #lastName="ngModel" name="lastName" id="lastName" 
                  pattern="^[a-zA-Z ]*" class="form-control" placeholder="Enter last name here..." />
                  <!-- <div [hidden]="lastName.valid || lastName.pristine" class="danger-text">
                    Last name is required
                  </div> -->
                  <div *ngIf="lastName.errors && lastName.dirty" class="danger-text">
                    <div *ngIf="lastName.errors.required">
                      Last Name is required 
                    </div>
                    <div *ngIf="lastName.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label">Email
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Email id for login & communication to admin user</span>
                <div class="controls">
                  <input autocomplete="off" type="email" (keyup)="validateUserEmailExists(admininfoForm)"
                    name="userEmail" id="userEmail" pattern="[a-zA-Z0-9_.+,-]{1,}@[a-zA-Z0-9.-]{2,}\.[a-zA-Z]{2,}"
                    #userEmail="ngModel" [(ngModel)]="userInfo.email" class="form-control"
                    placeholder="Enter email address here..." required />
                  <div *ngIf="userEmail.errors && userEmail.dirty" class="danger-text">
                    <div *ngIf="userEmail.errors.required">
                      Email is required
                    </div>
                    <div *ngIf="userEmail.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                  <div *ngIf="userEmailExists" class="danger-text">
                    User email already exits
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label">Mobile
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Mobile number to communicate the admin user</span>
                <div class="controls">
                  <input type="text" (keyup)="validateUserMobileExists()" (keypress)="_keyPress($event)"
                    [(ngModel)]="userInfo.phoneNo" required ng-pattern="/^[0-9]*$/" #userMobile="ngModel"
                    name="userMobile" id="userMobile" class="form-control" placeholder="Enter mobile number here..."
                    required />
                  <div [hidden]="userMobile.valid || userMobile.pristine" class="danger-text">
                    Mobile number is required
                  </div>
                  <div *ngIf="userMobileExists" class="danger-text">
                    User mobile already exits
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label">Password
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Temporary password to be given to account admin</span>
                <div class="controls">
                  <input class="form-control" [(ngModel)]="userInfo.password" #password="ngModel" required id="password"
                    name="password" type="password" placeholder="Enter password here..."
                    (keyup)="isStrongPassword = checkStrongPassword(userInfo.password)">
                  <!-- start : strong password check-->
                  <div>
                    <span *ngIf="userInfo.password && userInfo.password.length>0 && isStrongPassword"
                      style="background-color:#27c24c;color:white;padding:2px;padding-left: 5px;padding-right: 5px;"><i
                        class="fa fa-check-circle">&nbsp;</i>Strong Password</span>
                    <span *ngIf="userInfo.password && userInfo.password.length>0 && !isStrongPassword"
                      style="background-color:#f05050;color:white;padding:2px;padding-left: 5px;padding-right: 5px;"><i
                        class="fa fa-times-circle">&nbsp;</i>Weak Password</span>
                    <span class="pull-right" style="cursor: pointer;"><a
                        (click)="showPasswordPolicy = !showPasswordPolicy"><span
                          *ngIf="!showPasswordPolicy">Show</span><span *ngIf="showPasswordPolicy">Hide</span> password
                        policy</a></span>
                  </div>
                  <div *ngIf="showPasswordPolicy">
                    <span style="font-style: italic;">
                      Password must contain
                      <ol>
                        <li>Minimum 8 letters</li>
                        <li>At least 1 uppercase character</li>
                        <li>At least 1 lowercase character</li>
                        <li>At least 1 number</li>
                        <li>At least 1 special character</li>
                      </ol>
                    </span>
                  </div>
                  <!-- end : strong password check-->
                  <div [hidden]="password.valid || password.pristine" class="danger-text">
                    Password is required
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label">Confirm Password
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Repeat the password entered</span>
                <div class="controls">
                  <input class="form-control" [(ngModel)]="confirmPassword" #confirmPasswordText="ngModel" required
                    id="confirmPassword" type="password" name="confirmPassword"
                    placeholder="Enter confirm password here...">
                  <div [hidden]="confirmPasswordText.valid || confirmPasswordText.pristine" class="danger-text">
                    Confirm Password is required
                  </div>
                  <div *ngIf="userInfo.password != confirmPassword && confirmPasswordText.dirty" class="danger-text">
                    Password and confirm password should match
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label">Address Line1
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Flat/Door/Block No</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="userInfo.address.addressLine1" #addressLine1="ngModel"  
                  pattern=".*[a-zA-Z0-9].*" name="addressLine1" id="userAddressLine1" class="form-control"
                    placeholder="Enter address line1 here..." required />
                  <!-- <div [hidden]="addressLine1.valid || addressLine1.pristine" class="danger-text">
                    Address Line1 is required
                  </div> -->
                  <div *ngIf="addressLine1.errors && addressLine1.dirty" class="danger-text">
                    <div *ngIf="addressLine1.errors.required">
                      Address Line1 is required 
                    </div>
                    <div *ngIf="addressLine1.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div> 
                  
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label">AddressLine 2
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Area/Locality</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="userInfo.address.addressLine2" #addressLine2="ngModel"  
                  pattern=".*[a-zA-Z0-9].*" name="addressLine2" id="useAaddressLine2" class="form-control"
                    placeholder="Enter address line2 here..." required />
                  <!-- <div [hidden]="addressLine2.valid || addressLine2.pristine" class="danger-text">
                    Address Line2 is required
                  </div> -->
                  <div *ngIf="addressLine2.errors && addressLine2.dirty" class="danger-text">
                    <div *ngIf="addressLine2.errors.required">
                      Address Line2 is required 
                    </div>
                    <div *ngIf="addressLine2.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div> 
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label">District
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">District/City/Town</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="userInfo.address.district" #district="ngModel" name="district"  
                  pattern=".*[a-zA-Z].*"  id="userDistrict" class="form-control" placeholder="Enter district here..." required />
                  <!-- <div [hidden]="district.valid || district.pristine" class="danger-text">
                    District is required
                  </div> -->
                  <div *ngIf="district.errors && district.dirty" class="danger-text">
                    <div *ngIf="district.errors.required">
                      District is required 
                    </div>
                    <div *ngIf="district.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label">State
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">State</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="userInfo.address.state" #state="ngModel" name="state" id="userState"   
                  pattern="^[a-zA-Z ]*" class="form-control" placeholder="Enter state here..." required />
                  <!-- <div [hidden]="state.valid || state.pristine" class="danger-text">
                    State is required
                  </div> -->
                  <div *ngIf="state.errors && state.dirty" class="danger-text">
                    <div *ngIf="state.errors.required">
                       State is required
                    </div>
                    <div *ngIf="state.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div> 
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 clear-both">
              <div class=" form-group">
                <label class="form-label">Pincode
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Pincode</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="userInfo.address.zipcode" #pincode="ngModel" name="pincode"  
                  pattern="^[0-9 ]*"  id="userPincode" class="form-control" placeholder="Enter pincode here..." required />
                  <!-- <div [hidden]="pincode.valid || pincode.pristine" class="danger-text">
                    Pincode is required
                  </div> -->
                  <div *ngIf="pincode.errors && pincode.dirty" class="danger-text">
                    <div *ngIf="pincode.errors.required">
                      Pincode is required
                    </div>
                    <div *ngIf="pincode.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label">Country
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Country</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="userInfo.address.country" #country="ngModel" name="country"  
                  pattern="^[a-zA-Z ]*"  id="userCountry" class="form-control" placeholder="Enter country here..." required />
                  <!-- <div [hidden]="country.valid || country.pristine" class="danger-text">
                    Country name is required
                  </div> -->
                  <div *ngIf="country.errors && country.dirty" class="danger-text">
                    <div *ngIf="country.errors.required">
                      Country is required
                    </div>
                    <div *ngIf="country.errors.pattern">
                      Invalid input, please check and enter correct details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="form-group text-center space-20 col-xs-12" style="margin-top: 15px;">
            <button uiSref="personal" type="button" class="btn btn-raised btn-secondary mr-1"
              style="margin:20px;margin-left: 10px;margin-right:10px;" awPreviousStep>
              <span style="margin-right:10px;">
                <i class="feather ft-chevron-left"></i>
              </span> Previous</button>
            <button type="button" style="margin:20px;margin-left: 10px;margin-right:10px;" uiSref="work"
              class="btn btn-info btn-raised" [awGoToStep]="{stepIndex: 2}" (click)="validateNotificationConfig()"
              [disabled]="!admininfoForm.form.valid || confirmPassword != userInfo.password || !isStrongPassword || userEmailExists || userMobileExist">
              Next
              <span style="margin-left:10px;">
                <i class="feather ft-chevron-right"></i>
              </span>
            </button>
          </div>
        </aw-wizard-step>
        <aw-wizard-step [stepId]="3" [stepTitle]="'Notification Configuration'"
          [navigationSymbol]="{ symbol: accountInfo.id==null?'3':'2'}">
          <div
            [ngClass]="{'col-xs-12 col-sm-12 col-md-12 col-lg-12 mTop15':accountInfo.id != null,'col-xs-12 col-sm-12 col-md-12 col-lg-12 mTop15':accountInfo.id==null}">
            <div class="table-responsive">

              <p-table [value]="accountInfo.notificationEventList"
                [paginator]="accountInfo.notificationEventList!=null && accountInfo.notificationEventList.length>10"
                [rows]="10" #dt class="table table-striped">
                <ng-template pTemplate="header">
                  <tr style="height: 65px;">
                    <th class="col-lg-6" style="width:100px;text-align: center;">#
                    </th>
                    <th [pSortableColumn]="'label'">Event Name
                      <p-sortIcon [field]="'label'"></p-sortIcon>
                    </th>
                    <th>SMS</th>
                    <th>Email</th>
                    <th>Whatsapp</th>
                    <th>Mode</th>
                  </tr>
                  <tr *ngIf="accountInfo.notificationEventList==null || accountInfo.notificationEventList.length==0"
                    style="border-left: 1px solid #f4f4f4;border-right: 1px solid #f4f4f4;border-bottom: 1px solid #f4f4f4;">
                    <td colspan="5">
                      <div style="padding: 5px;text-align: center;">
                        No record found
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-event let-i="rowIndex">
                  <tr class="table-striped" style="cursor: pointer;">
                    <td style="text-align: center;">
                      {{i+1}}
                    </td>
                    <td>
                      {{event.label}}
                    </td>
                    <td style="text-align: center;">
                      <p-inputSwitch [(ngModel)]="event.smsEnabled" (click)="validateNotificationConfig()"
                        [hidden]="!event.sms"></p-inputSwitch>
                    </td>
                    <td style="text-align: center;">
                      <p-inputSwitch [(ngModel)]="event.emailEnabled" (click)="validateNotificationConfig()"
                        [hidden]="!event.email"></p-inputSwitch>
                    </td>
                    <td style="text-align: center;">
                      <p-inputSwitch [(ngModel)]="event.whatsappEnabled" (click)="validateNotificationConfig()"
                        [hidden]="!event.whatsapp"></p-inputSwitch>
                    </td>
                    <td style="text-align: center;">
                      <div class="btn-group-tristate">
                        <button [disabled]="!event.smsEnabled && !event.emailEnabled && !event.whatsappEnabled"
                          class="tri-state-toggle-button" (click)="selectstatus(i,'AUTO')"
                          [ngClass]="{'selected':  event.notificationMode === 'AUTO'}">Auto</button>
                        <button [disabled]="!event.smsEnabled && !event.emailEnabled && !event.whatsappEnabled"
                          class="tri-state-toggle-button" (click)="selectstatus(i,'MANUAL')"
                          [ngClass]="{'selected': event.notificationMode === 'MANUAL'}">Manual</button>
                        <button [disabled]="!event.smsEnabled && !event.emailEnabled && !event.whatsappEnabled"
                          class="tri-state-toggle-button" (click)="selectstatus(i,'BOTH')"
                          [ngClass]="{'selected':  event.notificationMode === 'BOTH'}">Both</button>
                      </div>

                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
          <div class="form-group col-xs-12 text-center space-20 col-xs-12" style="margin-top: 15px;">
            <button uiSref="personal" type="button" class="btn btn-raised btn-secondary mr-1"
              style="margin:20px;margin-left: 10px;margin-right:10px;" awPreviousStep>
              <span style="margin-right:10px;">
                <i class="feather ft-chevron-left"></i>
              </span> Previous</button>
            <button type="button" style="margin:20px;margin-left: 10px;margin-right:10px;" uiSref="work"
              class="btn btn-info btn-raised" id="btnnext" [awGoToStep]="{stepIndex: accountInfo.id == null? 3:2}"
              [disabled]="!validateNotificationConfigFlag">
              Next

              <span style="margin-left:10px;">
                <i class="feather ft-chevron-right"></i>
              </span>
            </button>
          </div>
        </aw-wizard-step>
        <aw-wizard-step [stepId]="4" [stepTitle]="'Review & Complete'"
          [navigationSymbol]="{ symbol: accountInfo.id==null?'4':'3'}">
          <div
            [ngClass]="{'col-xs-12 col-sm-12 col-md-12 col-lg-12 mTop15':accountInfo.id != null,'col-xs-12 col-sm-12 col-md-6 col-lg-6 mTop15':accountInfo.id==null}">
            <div class="table-responsive">
              <table class="table borderless" style="border: 1px solid lightgrey;">
                <tbody>
                  <tr style="background:#e0dfdf;">
                    <td colspan="2">Account Details</td>
                  </tr>
                  <tr>
                    <td>Account Name</td>
                    <td>{{accountInfo.name}}</td>
                  </tr>
                  <tr>
                    <td>Account Short Name</td>
                    <td>{{accountInfo.name}}</td>
                  </tr>
                  <tr>
                    <td>Trial Account</td>
                    <td>
                      <i *ngIf="accountInfo.isTrial" class="fa fa-check-square-o" style="color:darkgreen;"></i>
                      <i *ngIf="!accountInfo.isTrial" class="fa fa-times-circle-o" style="color:darkred;"></i>
                    </td>
                  </tr>
                  <tr *ngIf="accountInfo.isTrial">
                    <td>Trial Duration</td>
                    <td>{{accountInfo.trialDays}} days</td>
                  </tr>
                  <tr>
                    <td>Associated Reading Centes</td>
                    <td>
                      <span *ngFor="let item of accountInfo.readingCenters; let isLast=last">
                        {{item.itemName}}{{isLast ? '' : ', '}}
                      </span>
                    </td>
                  </tr>
                  <tr *ngIf="accountInfo.isAIEnabled">
                    <td>Associated AI Providers</td>
                    <td>
                      <span *ngFor="let item of accountInfo.aiProviders; let isLast=last">
                        {{item.itemName}}{{isLast ? '' : ', '}}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Contact Email</td>
                    <td>{{accountInfo.email}}</td>
                  </tr>
                  <tr>
                    <td>Contact Mobile</td>
                    <td>{{accountInfo.mobile}}</td>
                  </tr>
                  <tr>
                    <td>Address Line1</td>
                    <td>{{accountInfo.address.addressLine1}}</td>
                  </tr>
                  <tr>
                    <td>Address Line2</td>
                    <td>{{accountInfo.address.addressLine2}}</td>
                  </tr>
                  <tr>
                    <td>District</td>
                    <td>{{accountInfo.address.district}}</td>
                  </tr>
                  <tr>
                    <td>State</td>
                    <td>{{accountInfo.address.state}}</td>
                  </tr>
                  <tr>
                    <td>Pincode</td>
                    <td>{{accountInfo.address.zipcode}}</td>
                  </tr>
                  <tr>
                    <td>Country</td>
                    <td>{{accountInfo.address.country}}</td>
                  </tr>
                  <tr>
                    <td>Language</td>
                    <td>{{getLanguage()}}</td>
                  </tr>
                  <tr>
                    <td>Timezone</td>
                    <td>{{getTimeZone()}}</td>
                  </tr>
                  <tr>
                    <td>AI Feature</td>
                    <td>
                      <span *ngIf="accountInfo.isAIEnabled" style="color:darkgreen">Enabled</span>
                      <span *ngIf="!accountInfo.isAIEnabled">Disabled</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Subscription Type</td>
                    <td>
                      <span *ngIf="subscriptionType" style="color:darkgreen">Postpaid</span>
                      <span *ngIf="!subscriptionType">Prepaid</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Roles can manage payment</td>
                    <td>
                      <span>{{getUserRoleName(rolesAssignedForPayment)}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Manual MRN Entry</td>
                    <td>
                      <span *ngIf="accountInfo.isManualMRN" style="color:darkgreen">Enabled</span>
                      <span *ngIf="!accountInfo.isManualMRN">Disabled</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Can Operator Email Reports</td>
                    <td>
                      <span *ngIf="accountInfo.isEmailReportEnabled" style="color:darkgreen">Enabled</span>
                      <span *ngIf="!accountInfo.isEmailReportEnabled">Disabled</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Need Patient Profile Picture?</td>
                    <td>
                      <span *ngIf="accountInfo.patientPicNeed" style="color:darkgreen">Yes</span>
                      <span *ngIf="!accountInfo.patientPicNeed">No</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Has Individual Owner?</td>
                    <td>
                      <span *ngIf="accountInfo.hasIndividualOwner" style="color:darkgreen">Yes</span>
                      <span *ngIf="!accountInfo.patientPicNeed">Disabled</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Enable automatic emailing of the patient reports?</td>
                    <td>
                      <span *ngIf="accountInfo.autoEmailPatientReport" style="color:darkgreen">Yes</span>
                      <span *ngIf="!accountInfo.autoEmailPatientReport">Disabled</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!--start : show notification config details-->
              <table class="table borderless" style="border: 1px solid lightgrey;">
                <tbody>
                  <tr style="background:#e0dfdf;">
                    <td colspan="5">Notification Configuration Details</td>
                  </tr>
                  <tr>
                    <td>Event Name</td>
                    <td>SMS</td>
                    <td>Email</td>
                    <td>Whatsapp</td>
                    <td>Mode</td>
                  </tr>
                  <tr *ngFor="let event of accountInfo.notificationEventList">
                    <td>{{event.label}}</td>
                    <td>
                      <i *ngIf="event.smsEnabled" class="fa fa-check-square-o" style="color:darkgreen;"></i>
                      <i *ngIf="!event.smsEnabled" class="fa fa-times-circle-o" style="color:darkred;"></i>
                    </td>
                    <td>
                      <i *ngIf="event.emailEnabled" class="fa fa-check-square-o" style="color:darkgreen;"></i>
                      <i *ngIf="!event.emailEnabled" class="fa fa-times-circle-o" style="color:darkred;"></i>
                    </td>
                    <td>
                      <i *ngIf="event.whatsappEnabled" class="fa fa-check-square-o" style="color:darkgreen;"></i>
                      <i *ngIf="!event.whatsappEnabled" class="fa fa-times-circle-o" style="color:darkred;"></i>
                    </td>
                    <td>
                      <span style="color:rgb(91, 91, 248);font-size: 16px;"
                        *ngIf="event.notificationMode ==='AUTO'">Auto</span>
                      <span style="color:rgb(91, 91, 248);font-size: 16px;"
                        *ngIf="event.notificationMode ==='MANUAL'">Manual</span>
                      <span style="color:rgb(124, 124, 218);font-size: 16px;"
                        *ngIf="event.notificationMode ==='BOTH'">Both</span>
                      <span style="color:rgb(148, 148, 150)" *ngIf="event.notificationMode == null ">N/A</span>

                    </td>
                  </tr>
                </tbody>
              </table>
              <!--end : show notification config details-->
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 mTop15" *ngIf="accountInfo.id==null">
            <div class="table-responsive">
              <table class="table borderless" style="border: 1px solid lightgrey;">
                <tbody>
                  <tr style="background:#e0dfdf;">
                    <td colspan="2">User Details</td>
                  </tr>
                  <tr>
                    <td>User Name</td>
                    <td>{{userInfo.title}}{{userInfo.firstName}} {{userInfo.lastName}}</td>
                  </tr>
                  <tr>
                    <td>Gender</td>
                    <td>{{userInfo.gender}}</td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>{{userInfo.email}}</td>
                  </tr>
                  <tr>
                    <td>Mobile</td>
                    <td>{{userInfo.phoneNo}}</td>
                  </tr>
                  <tr>
                    <td>Password</td>
                    <td>
                      <span *ngIf="showPassword">{{userInfo.password}}</span>
                      <span *ngIf="!showPassword">**********</span>
                      <i class="fa fa-eye float-right" style="cursor:pointer;font-size: 17px;color: #7ac0e4;"
                        *ngIf="showPassword" (click)="showPassword = ! showPassword"></i>
                      <i class="fa fa-eye-slash float-right" style="cursor:pointer;font-size: 17px;color: #7ac0e4;"
                        *ngIf="!showPassword" (click)="showPassword = ! showPassword"></i>
                    </td>
                  </tr>
                  <tr>
                    <td>Address Line1</td>
                    <td>{{userInfo.address.addressLine1}}</td>
                  </tr>
                  <tr>
                    <td>Address Line2</td>
                    <td>{{userInfo.address.addressLine2}}</td>
                  </tr>
                  <tr>
                    <td>District</td>
                    <td>{{userInfo.address.district}}</td>
                  </tr>
                  <tr>
                    <td>State</td>
                    <td>{{userInfo.address.state}}</td>
                  </tr>
                  <tr>
                    <td>Pincode</td>
                    <td>{{userInfo.address.zipcode}}</td>
                  </tr>
                  <tr>
                    <td>Country</td>
                    <td>{{userInfo.address.country}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="form-group col-xs-12 text-center space-20 col-xs-12" style="margin-top: 15px;">
            <button uiSref="personal" type="button" class="btn btn-raised btn-secondary mr-1"
              style="margin:20px;margin-left: 10px;margin-right:10px;" (click)="previousWizardClick()" awPreviousStep>
              <span style="margin-right:10px;">
                <i class="feather ft-chevron-left"></i>
              </span> Previous</button>
            <button type="button" (click)="onComplete()" style="margin:20px;margin-left: 10px;margin-right:10px;"
              uiSref="work" class="btn btn-info btn-raised" [awGoToStep]="{stepIndex: 4}">
              Submit
              <span style="margin-left:10px;">
                <i class="feather ft-chevron-right"></i>
              </span>
            </button>
          </div>
        </aw-wizard-step>
      </aw-wizard>
    </ng-template>
  </div>
</div>